var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width: " + _vm.dataWidth + "; height: " + _vm.dataHeight))},[_c(_vm.loaderType,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }